"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
var _useComponentVisible = _interopRequireDefault(require("../../hooks/useComponentVisible"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Tooltip = _ref => {
  let {
    title,
    content,
    position,
    className,
    isVisible,
    faIcon,
    showTitle
  } = _ref;
  // Init useComponentVisible hook
  const componentVisible = _useComponentVisible.default;
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = componentVisible(isVisible);
  const [mount, setMount] = (0, _react.useState)(false);
  const onClickOpen = () => {
    setIsComponentVisible(true);
  };
  const onClickClose = () => {
    setIsComponentVisible(false);
  };
  const onKeyClose = key => {
    if (key === 'Enter') {
      onClickClose();
    }
  };
  (0, _react.useEffect)(() => {
    if (isComponentVisible && !mount) {
      setMount(true);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isComponentVisible, ref, mount]);

  // Logic for left or right aligned. Default left.
  const ttPosition = position === 'right' ? 'right' : 'left';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `tooltip ${className}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    title: "Click to view Educational moment",
    className: "tooltip__icon"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "button button--small button--only-icon button--tertiary",
    onClick: onClickOpen,
    type: "button",
    "aria-haspopup": "dialog"
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    className: `great-icon fas ${faIcon}`
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "visually-hidden"
  }, title))), isComponentVisible && /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: `tooltip__text tooltip__text--${ttPosition} bg-white radius`,
    role: "dialog",
    "aria-labelledby": "tooltip-title"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "tooltip__close",
    title: "Click or press Escape to close Educational moment",
    onClick: onClickClose,
    onKeyUp: e => onKeyClose(e.key),
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    className: "fas fa-times text-blue-deep-80"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "visually-hidden"
  }, "Click or press Escape to close Educational moment")), /*#__PURE__*/_react.default.createElement("h2", {
    id: "tooltip-title",
    className: `tooltip__title h-xs p-t-0 p-b-0 ${showTitle ? '' : 'visually-hidden'}`
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip__content text-blue-deep-80"
  }, (0, _reactHtmlParser.default)(content))));
};
exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  className: _propTypes.default.string,
  content: _propTypes.default.string.isRequired,
  faIcon: _propTypes.default.string,
  isVisible: _propTypes.default.bool,
  position: _propTypes.default.string,
  title: _propTypes.default.string,
  showTitle: _propTypes.default.bool
};
Tooltip.defaultProps = {
  className: '',
  faIcon: 'fa-book',
  isVisible: false,
  position: 'left',
  title: 'Helpful hint',
  showTitle: true
};
